import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-public-layout",
    templateUrl: "./public-layout.component.html",
    styleUrls: ["./public-layout.component.scss"],
    standalone: false,
})
export class PublicLayoutComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
